export default {
    //登录接口
    login: "client/member/skipAuth/login",
    //注册
    register: "client/member/skipAuth/register/save",
    //短信注册
    messageRegister: "client/member/skipAuth/quiesce/register/save",
    //查找密码
    findPassword: "client/member/skipAuth/user/index/retrievePassword",
    //修改密码
    changePassword: "client/member/user/center/changePassword",
    //绑定微信信息
    bindWechatInfo: "client/member/skipAuth/bindPhone",
    //检测是否新数据
    isRegister: "client/member/skipAuth/select/phone/exist",
    //获取微信信息
    getWechatInfo: "client/member/skipAuth/wxlogin",
    //是否包含用户
    hasUser: "client/member/skipAuth/hasUserPhone",
    //解除微信绑定
    removeWechat: "client/member/relieve/bind/wechat",
    //查询微信账户信息
    queryWechatInfo: "client/member/skipAuth/get/WeChat/info",
    //查询微信关联信息
    queryWechatRelevanceInfo: "client/member/skipAuth/check/relevance/user",
    //微信注册成用户
    wechatRegister: "client/member/skipAuth/bindPhone",
    //用户中心绑定微信
    bindWechatInfo: "client/member/bind/wechat",
};
